export const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1654064756668-16a32248d391?q=80&w=3290&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    label: "Modern kitchen utensils",
  },
  {
    src: "https://images.unsplash.com/photo-1654064756910-974764816931?q=80&w=3290&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    label: "Quality is important",
  },
  {
    src: "https://images.unsplash.com/photo-1654064756026-c04ed4594825?q=80&w=3290&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    label: "Affordable and reliable",
  },
  {
    src: "https://images.unsplash.com/photo-1654064755672-e1c557e55bf7?q=80&w=3290&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    label: "Simple but special",
  },
  {
    src: "https://images.unsplash.com/photo-1654064756771-383a36482ca5?q=80&w=3290&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    label: "Designed with care",
  },
];
